import type { Catalog } from '@smarton-pbx/shared';

export const queues: Catalog = {
  // The person's status (header menu).
  Available: 'Pasiekiamas',
  'On a break': 'Pertraukoje',
  Offline: 'Neprisijungęs',
  'Your calls and your queues ring you': 'Jums skamba jūsų skambučiai ir eilės',
  'Not rung; you keep your queue places': 'Neskambinama; vietos eilėse išlieka',
  'Not rung; out of your queues': 'Neskambinama; esate išėję iš eilių',
  'Your status': 'Jūsų būsena',
  'Your queues': 'Jūsų eilės',

  // Durations.
  '{n} s': '{n} s',
  '{n} min': '{n} min.',
  '{m} min {s} s': '{m} min. {s} s',
  'no limit': 'be apribojimo',

  // Setting queues up.
  'Delete the queue {name}?': 'Ištrinti eilę „{name}“?',
  'Callers wait in a queue, with hold music and their place in line, while its people are rung by the queue’s rule.':
    'Skambinantieji laukia eilėje klausydamiesi laukimo muzikos ir girdėdami savo vietą, o eilė skambina darbuotojams pagal savo taisyklę.',
  'Live view': 'Tiesioginė peržiūra',
  'New queue': 'Nauja eilė',
  'No queues yet': 'Eilių dar nėra',
  'Make a queue, add its people, then point a number at it on the Numbers page.':
    'Sukurkite eilę, pridėkite jos darbuotojus, tada puslapyje „Numeriai“ nukreipkite į ją numerį.',
  Queue: 'Eilė',
  Rule: 'Taisyklė',
  '{region} · rings {ring} s each · waits {wait}': '{region} · kiekvienam skambinama {ring} s · laukimas: {wait}',
  '{n} of {total} in': '{n} iš {total} eilėje',
  'Who is rung': 'Kam skambinama',
  'Ring each person (seconds)': 'Skambinti kiekvienam (s)',
  'Then the next is tried': 'Tada skambinama kitam',
  'Longest wait': 'Ilgiausias laukimas',
  'Then the queue’s fallback': 'Tada – eilės atsarginis veiksmas',
  'No limit': 'Be apribojimo',
  'When nobody answers': 'Kai niekas neatsiliepia',
  'Take a message for the queue': 'Palikti žinutę eilei',
  'Hang up': 'Baigti skambutį',
  'Wrap-up after a call (seconds)': 'Laikas po pokalbio (s)',
  'Before the person is rung again': 'Prieš vėl skambinant darbuotojui',
  'Tell managers about a wait of': 'Pranešti vadovams, kai laukiama',
  'Don’t tell them': 'Nepranešti',
  'Tell callers their place every (seconds)': 'Pranešti vietą eilėje kas (s)',
  'Hold music': 'Laukimo muzika',
  'Your own on the Hold music page': 'Savo muziką įkelkite puslapyje „Laukimo muzika“',
  'The standard music': 'Standartinė muzika',
  '{name} (no tracks yet)': '{name} (dar nėra kūrinių)',
  'Tell callers their place in line': 'Pranešti skambinantiesiems jų vietą eilėje',
  'Callers may press 1 to keep their place and be called back': 'Skambinantieji gali paspausti 1, kad išsaugotų vietą ir jiems būtų perskambinta',
  'Priority 1 is rung first; people with a higher number when those before them are busy or away.':
    'Pirmiausia skambinama darbuotojams su prioritetu 1, o tiems, kurių skaičius didesnis, – kai ankstesni užimti arba nepasiekiami.',
  'Priority of {name}': '{name}: prioritetas',
  'Priority {n}': 'Prioritetas {n}',
  'Person to add': 'Pridedamas darbuotojas',
  'Add a person…': 'Pridėti darbuotoją…',
  '{name} (ext. {extension})': '{name} (vid. nr. {extension})',
  'Make queue': 'Sukurti eilę',

  // Who is rung (shared queueStrategyNames).
  'Ring everyone': 'Skambinti visiems',
  'Round robin': 'Paeiliui',
  'In order of priority': 'Pagal prioritetą',
  'Longest since their last call': 'Ilgiausiai be skambučio',
  'Fewest calls today': 'Mažiausiai skambučių šiandien',
  Random: 'Atsitiktinai',

  // Queues now.
  Free: 'Laisvas',
  Ringing: 'Skamba',
  'Wrap-up': 'Po pokalbio',
  'Left the queue': 'Paliko eilę',
  'Queues now': 'Eilės dabar',
  'Who is waiting and for how long, and who is free to answer. Updates as it happens.':
    'Kas laukia ir kiek laiko, ir kas gali atsiliepti. Atnaujinama iš karto.',
  'Set up queues': 'Nustatyti eiles',
  'No queues to show': 'Nėra eilių',
  'Queues you are in, or manage, appear here.': 'Čia rodomos eilės, kuriose esate arba kurias prižiūrite.',
  'Today {calls} · {answered} answered · {missed} missed · longest wait {wait}':
    'Šiandien {calls} · atsiliepta {answered} · praleista {missed} · ilgiausias laukimas {wait}',
  '{n} calls': { one: '{n} skambutis', few: '{n} skambučiai', other: '{n} skambučių' },
  'Waiting ({n})': 'Laukia ({n})',
  'Nobody is waiting.': 'Niekas nelaukia.',

  // The call back list.
  'Today {time}': 'Šiandien {time}',
  'Hung up while waiting': 'Padėjo ragelį laukdamas',
  'Waited too long': 'Laukė per ilgai',
  'Asked to be called back': 'Paprašė perskambinti',
  'Queue callers nobody answered, and those who asked to be called back. Each stays here until someone marks it done.':
    'Eilės skambinantieji, į kurių skambučius niekas neatsiliepė, ir tie, kurie paprašė perskambinti. Kiekvienas lieka čia, kol kas nors pažymi, kad atlikta.',
  Show: 'Rodyti',
  'To call back': 'Reikia perskambinti',
  'Nobody to call back': 'Nėra kam perskambinti',
  'Nothing done yet': 'Dar nieko neatlikta',
  'Unanswered queue calls appear here.': 'Čia rodomi eilės skambučiai, į kuriuos niekas neatsiliepė.',
  Caller: 'Skambinantysis',
  Why: 'Priežastis',
  When: 'Laikas',
  'Place kept in the queue': 'Vieta eilėje išsaugota',
  'Done by {name}': 'Atliko {name}',
  Reopen: 'Grąžinti',

  // Queue reports (on the dashboard).
  'Average wait': 'Vidutinis laukimas',
  'Average talk': 'Vidutinis pokalbis',
  'Who is in it': 'Kas joje',
};
